module.exports = __webpack_public_path__ + "img/members-icon-active.de350576.svg";